/* global axios */
import ApiClient from './ApiClient';

class EvolutionConnectionsAPI extends ApiClient {
  constructor() {
    super('evolution_connections', { accountScoped: true });
  }

  getStatus(fresh = false) {
    return axios.get(this.url, { params: fresh ? { fresh: 1 } : {} });
  }

  qrcode(inboxId) {
    return axios.post(`${this.url}/${inboxId}/qrcode`);
  }

  restart(inboxId) {
    return axios.post(`${this.url}/${inboxId}/restart`);
  }
}

export default new EvolutionConnectionsAPI();
